/* Langsomt Nok CRO 13 - optional add-ons, honest quantity totals and one in-flight request. */
(function () {
  'use strict';
  function init(section) {
    if (section.dataset.lnInitialized === 'true') return;
    var json = section.querySelector('[data-ln-base-variants]');
    var variants;
    try { variants = JSON.parse(json.textContent); if (!Array.isArray(variants)) return; } catch (error) { return; }
    section.dataset.lnInitialized = 'true';
    var form = document.querySelector('#ln-product-form');
    var variantInput = document.querySelector(section.dataset.baseVariantSelector || '#ln-variant-id');
    var quantityInput = form && form.querySelector('[name="quantity"]');
    var cards = Array.from(section.querySelectorAll('[data-ln-addon-card]'));
    var toggles = Array.from(section.querySelectorAll('[data-ln-addon-toggle]'));
    var add = section.querySelector('[data-ln-add-set]');
    var total = section.querySelector('[data-ln-total]');
    var basePrice = section.querySelector('[data-ln-base-price]');
    var selection = section.querySelector('[data-ln-selection]');
    var status = section.querySelector('[data-ln-status]');
    var max = Math.max(1, Math.min(3, Number(section.dataset.maxAddons) || 3));
    var handle = section.dataset.baseHandle || '';
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var cartUrl = section.dataset.cartUrl || root + 'cart';
    var formatter = new Intl.NumberFormat(document.documentElement.lang || 'da-DK', { style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'DKK' });
    var pending = false;
    var needsCartCheck = false;
    var locks = [];
    function money(cents) { return formatter.format(Number(cents) / 100); }
    function base() { return variants.find(function (v) { return variantInput && String(v.id) === String(variantInput.value); }) || null; }
    function qty() { var n = quantityInput ? Number(quantityInput.value) : 1; return Number.isSafeInteger(n) && n >= 1 ? n : null; }
    function chosen() { return toggles.filter(function (t) { return t.checked; }); }
    function track(name, detail) { document.dispatchEvent(new CustomEvent('ln:event', { detail: Object.assign({ event: name, product_handle: handle }, detail || {}) })); }
    function update() {
      var v = base(), n = qty(), choices = chosen();
      var sum = choices.reduce(function (value, t) { return value + Number(t.dataset.price); }, 0);
      var valid = !!(v && v.available && n && choices.length > 0 && choices.length <= max && Number.isFinite(sum));
      if (basePrice) basePrice.textContent = v && n ? (n > 1 ? n + ' stk. · ' : '') + money(v.price * n) : 'Vælg antal og variant';
      if (total) total.textContent = v && n && Number.isFinite(sum) ? money(v.price * n + sum) : 'Vælg antal og variant';
      if (selection) selection.textContent = !n ? 'Vælg et helt antal på mindst 1' : choices.length ? n + ' stk. af hovedproduktet + ' + choices.length + ' tilkøb à 1 stk.' : 'Tilkøb er valgfrie. Vælg mindst ét for at bruge denne knap.';
      if (add) add.disabled = pending || needsCartCheck || !valid;
      toggles.forEach(function (t) {
        t.disabled = pending || (!t.checked && choices.length >= max);
        var card = t.closest('[data-ln-addon-card]');
        if (card) {
          card.classList.toggle('is-selected', t.checked);
          var select = card.querySelector('[data-ln-addon-variant]');
          if (select) select.disabled = pending || !t.checked;
        }
      });
    }
    function freezeMain() {
      locks = form ? Array.from(form.querySelectorAll('button,input:not([type="hidden"]),select')).map(function (control) {
        var previous = { control: control, disabled: control.disabled };
        control.disabled = true;
        return previous;
      }) : [];
      document.querySelectorAll('[data-sticky-add]').forEach(function (control) { locks.push({ control: control, disabled: control.disabled }); control.disabled = true; });
    }
    function restoreMain() { locks.forEach(function (item) { item.control.disabled = item.disabled; }); locks = []; }
    function cartCheckMessage(message) {
      if (!status) return;
      status.textContent = message + ' Kontrollér kurven, før du prøver igen. ';
      var link = document.createElement('a'); link.href = cartUrl; link.textContent = 'Se kurven'; status.appendChild(link);
    }
    toggles.forEach(function (t) {
      t.addEventListener('change', function () {
        if (pending) return;
        if (chosen().length > max) t.checked = false;
        if (status && !needsCartCheck) status.textContent = '';
        update(); track('bundle_addon_toggle', { addon_variant_id: String(t.value), selected: t.checked });
      });
    });
    cards.forEach(function (card) {
      var select = card.querySelector('[data-ln-addon-variant]');
      var toggle = card.querySelector('[data-ln-addon-toggle]');
      if (!select || !toggle) return;
      select.addEventListener('change', function () {
        var option = select.selectedOptions[0];
        if (!option || pending) return;
        toggle.value = option.value; toggle.dataset.price = option.dataset.price;
        var label = card.querySelector('[data-ln-addon-price]'); if (label) label.textContent = money(option.dataset.price);
        update();
      });
    });
    if (quantityInput) ['input','change'].forEach(function (event) { quantityInput.addEventListener(event, update); });
    document.addEventListener('ln:variant-change', function (event) { if (event.detail && event.detail.productHandle === handle) update(); });
    if (form) form.querySelectorAll('.ln-pdp__swatch').forEach(function (button) { button.addEventListener('click', function () { window.setTimeout(update, 0); }); });
    if (add) add.addEventListener('click', async function () {
      if (pending || needsCartCheck) return;
      var v = base(), n = qty(), choices = chosen();
      if (!v || !v.available || !n || !choices.length || choices.length > max) { update(); return; }
      var ids = choices.map(function (t) { return Number(t.value); });
      if (!ids.every(function (id) { return Number.isSafeInteger(id) && id > 0; })) return;
      var group = 'ln-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2,7);
      var items = [{ id: Number(v.id), quantity: n, properties: { _ln_group: group, _ln_role: 'base', _ln_offer: handle } }];
      ids.forEach(function (id) { items.push({ id: id, quantity: 1, properties: { _ln_group: group, _ln_role: 'addon', _ln_offer: handle } }); });
      pending = true; freezeMain(); add.setAttribute('aria-busy', 'true'); update();
      if (status) status.textContent = 'Lægger dine valgte varer i kurven...';
      track('bundle_add_attempt', { base_variant_id: String(v.id), base_quantity: n, addon_count: ids.length });
      try {
        var response = await fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) });
        var payload = await response.json();
        if (!response.ok) throw new Error(payload.description || payload.message || 'Varerne kunne ikke lægges i kurven.');
        track('bundle_add_success', { base_variant_id: String(v.id), base_quantity: n, addon_count: ids.length });
        if (status) status.textContent = 'De valgte varer er lagt i kurven.';
        window.location.assign(cartUrl);
      } catch (error) {
        pending = false; needsCartCheck = true; restoreMain(); add.removeAttribute('aria-busy');
        cartCheckMessage(error && error.message ? error.message : 'Vi kunne ikke bekræfte opdateringen.');
        track('bundle_add_error', { base_variant_id: String(v.id), base_quantity: n });
        update();
      }
    });
    update();
  }
  function initAll() { document.querySelectorAll('[data-ln-buy-together]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
